import { ApiVersion } from 'models/ApiVersion';
import { FooterGroup } from 'models/FooterGroup';
import { IFooterModel } from 'models/IFooterModel';
import { PageState } from 'models/PageState';
import { RedFooterModel } from 'models/RedFooterModel';

export const selectPhonenumber = (state: PageState) => state.header.contact.phonenumber;
export const selectPhoneOpen = (state: PageState) => state.header.contactSection?.title;

export const selectContactBlocks = (state: PageState) => state.header.contactSection?.blocks;

const isRedFooter = (footer: IFooterModel): footer is RedFooterModel =>
  footer.version === ApiVersion.RD3;

export const selectFooterGroups = (state: PageState): FooterGroup[] | undefined =>
  isRedFooter(state.footer) ? state.footer.allFooterGroups : undefined;
